import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  countries = [
    {
      name: "Egypt",
      name_ar: "مصر",
      short: "EG",
      code_plus: "+20",
      code: "20",
      flag: "/assets/icons/Flags/EG.svg",
      selected: true
    },
    {
      name: "Saudi Arabia",
      name_ar: "المملكة العربية السعودية",
      short: "SA",
      code_plus: "+966",
      code: "966",
      flag: "/assets/icons/Flags/SA.svg",
      selected: true
    },
    {
      name: "Qatar",
      name_ar: "قطر",
      short: "QA",
      code_plus: "+974",
      code: "974",
      flag: "/assets/icons/Flags/QA.svg",
      selected: true
    },
    {
      name: "Bahrain",
      name_ar: "البحرين",
      short: "BH",
      code_plus: "+973",
      code: "973",
      flag: "/assets/icons/Flags/BH.svg",
      selected: true
    },
    {
      name: "Oman",
      name_ar: "سلطنة عمان",
      short: "OM",
      code_plus: "+968",
      code: "968",
      flag: "/assets/icons/Flags/OM.svg",
      selected: true
    },
    {
      name: "United Arab Emirates",
      name_ar: "الإمارات العربية المتحدة",
      short: "AE",
      code_plus: "+971",
      code: "971",
      flag: "/assets/icons/Flags/AE.svg",
      selected: true
    },
    {
      name: "Kuwait",
      name_ar: "الكويت",
      short: "KW",
      code_plus: "+965",
      code: "965",
      flag: "/assets/icons/Flags/KW.svg",
      selected: true
    },
    {
      name: "Jordan",
      name_ar: "الأردن",
      short: "JO",
      code_plus: "+962",
      code: "962",
      flag: "/assets/icons/Flags/JO.svg",
      selected: true
    },
    {
      name: "Iraq",
      name_ar: "العراق",
      short: "IQ",
      code_plus: "+964",
      code: "964",
      flag: "/assets/icons/Flags/IQ.svg",
      selected: true
    }
  ];
  constructor() { }
}
